import alert from '@/components/Dialog/BaseAlert.vue'
import confirm from '@/components/Dialog/BaseConfirm.vue'

const TYPE_ALERT = '$alert'
const TYPE_CONFIRM = '$confirm'
const plugin = {
  vm: null,
  queue: [],
  create (type, Vue, Ctor, propsData) {
    if (this.vm) {
      this.queue.push({ type, Ctor, propsData })
      return
    }
    const el = document.createElement('div')
    const vm = new Ctor({
      propsData,
      el,
      data () {
        return {
          show: true
        }
      }
    })
    this.vm = vm

    vm.$on('close', () => {
      setTimeout(() => {
        vm.$destroy()
        this.vm = null
        if (this.queue.length > 0) {
          let { type, propsData } = this.queue.shift()
          const { content, closeHandler, errorHandler } = propsData
          Vue.prototype[type](content, null, propsData).then(closeHandler).catch(errorHandler)
        }
      }, 400)
    })
  },
  install: function (Vue) {
    const self = this
    Object.defineProperties(Vue.prototype, {
      [TYPE_ALERT]: {
        get () {
          return (content, closeHandler, propsData = {}) => {
            Vue.util.extend(propsData, { content })
            const Constructor = Vue.extend(alert)

            return new Promise((resolve, reject) => {
              propsData.closeHandler = closeHandler || resolve
              propsData.errorHandler = reject
              self.create(TYPE_ALERT, Vue, Constructor, propsData)
            })
          }
        }
      },
      [TYPE_CONFIRM]: {
        get () {
          return (content, closeHandler, propsData = {}) => {
            Vue.util.extend(propsData, { content })
            const Constructor = Vue.extend(confirm)

            return new Promise((resolve, reject) => {
              propsData.closeHandler = closeHandler || resolve
              propsData.errorHandler = reject
              self.create(TYPE_CONFIRM, Vue, Constructor, propsData)
            })
          }
        }
      }
    })
    window.$alert = Vue.prototype.$alert
    window.$confirm = Vue.prototype.$confirm
  }
}

export default plugin
